class CompareProduct {
  constructor() {
    this.storageKey = 'm-compare-products';
    this.fr = document.documentElement.lang.startsWith('fr');
    this.products = [];
    try { const saved = JSON.parse(localStorage.getItem(this.storageKey) || '[]'); if (Array.isArray(saved)) this.products = [...new Set(saved.filter(h => typeof h === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(h)))]; } catch (_) {}
    this.isComparePage = MinimogSettings.template === 'page.product-compare';
    document.addEventListener('click', e => {
      const remove = e.target.closest('.m-compare-remove-button');
      const button = e.target.closest('.m-compare-button');
      if (!remove && !button) return;
      e.preventDefault();
      const target = remove || button, handle = target.dataset.productHandle;
      if (!handle || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(handle)) return;
      if (remove || this.products.includes(handle)) {
        this.products = this.products.filter(h => h !== handle);
        document.querySelectorAll('.m-compare-card').forEach(card => { if (card.dataset.productHandle === handle) card.remove(); });
      } else {
        if (this.products.length >= 3) { this.announce(this.fr ? 'Vous pouvez comparer 3 variétés. Retirez-en une avant d’en ajouter une autre.' : 'Compare up to 3 varieties. Remove one before adding another.'); return; }
        this.products.push(handle);
      }
      let stored=true;
      try { localStorage.setItem(this.storageKey, JSON.stringify(this.products)); } catch (_) { stored=false; }
      this.sync();
      this.announce(stored ? (this.fr ? `${this.products.length} variété${this.products.length === 1 ? '' : 's'} sélectionnée${this.products.length === 1 ? '' : 's'}.` : `${this.products.length} ${this.products.length === 1 ? 'variety' : 'varieties'} selected.`) : (this.fr ? 'Votre navigateur ne permet pas de conserver la sélection pour ouvrir la comparaison.' : 'Your browser could not save this selection for the comparison page.'));
    });
    this.sync();
    if (this.isComparePage) this.renderComparePage();
    // Collection filters replace their product grid without a full navigation.
    this.observer = new MutationObserver(records => { if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('.m-compare-button') || n.querySelector?.('.m-compare-button'))))) this.sync(); });
    this.observer.observe(document.body, {childList:true, subtree:true});
  }
  announce(message) {
    let status = document.getElementById('cv-compare-status');
    if (!status) { status = document.createElement('p'); status.id='cv-compare-status'; status.setAttribute('role','status'); status.style.cssText='position:fixed;bottom:20px;left:16px;right:16px;z-index:10000;padding:14px;background:#193e2d;color:white;border-radius:8px;text-align:center;pointer-events:none'; document.body.append(status); }
    status.hidden=false; status.textContent=message; clearTimeout(this.statusTimer); this.statusTimer=setTimeout(()=>{status.hidden=true;},5000);
  }
  setCompareButtonsState = () => this.sync();
  sync() {
    document.querySelectorAll('.m-compare-button').forEach(button=>{
      const active=this.products.includes(button.dataset.productHandle);
      button.classList.toggle('added-to-compare',active); button.setAttribute('aria-pressed',String(active));
      const label=button.querySelector('.m-compare-button-text');
      if(label) label.textContent=active?(this.fr?'Retirer de la comparaison':'Remove from comparison'):(this.fr?'Comparer':'Compare');
    });
    document.querySelectorAll('.m-compare-count').forEach(count=>{count.textContent=this.products.length;count.classList.toggle('m:hidden',this.products.length===0);});
    if(this.isComparePage) {
      const empty=document.querySelector('.m-compare-no-products'); if(empty) empty.classList.toggle('m:hidden',this.products.length>0);
    }
  }
  async renderComparePage() {
    const container=document.querySelector('.m-compare-page-content__wrapper'); if(!container) return;
    const root=window.Shopify?.routes?.root || (this.fr?'/fr/':'/');
    for(const handle of this.products) {
      const card=document.createElement('div');card.className='m-compare-card';card.dataset.productHandle=handle;container.append(card);
      try {
        const response=await fetch(`${root}products/${encodeURIComponent(handle)}?view=compare`);
        if(!response.ok) throw new Error('unavailable');
        const html=await response.text();const parsed=new DOMParser().parseFromString(html,'text/html');const product=parsed.querySelector('.m-product-card');
        if(!product) throw new Error('unavailable');
        card.append(product);
      } catch (_) {
        const message=document.createElement('p');message.textContent=this.fr?'Cette variété est indisponible pour le moment.':'This variety could not be loaded. Please try again.';
        const remove=document.createElement('button');remove.type='button';remove.className='m-compare-remove-button m-button';remove.dataset.productHandle=handle;remove.textContent=this.fr?'Retirer':'Remove';card.append(message,remove);
      }
    }
    container.classList.add('is-visible');this.sync();
  }
}
MinimogTheme.CompareProduct = new CompareProduct();
